import React, { useState, useEffect, Fragment } from "react";
import "../components/PriceTable/PriceTable.scss";

import star from "../assets/icons/star.svg";
import down from "../assets/icons/down.svg";
import up from "../assets/icons/up.svg";
import arrow from "../assets/icons/Arrow_left.svg";
import { getFlagUrl } from "../utils/getFlagUrl";

const translations = {
  USD: "دلار",
  EUR: "یورو",
  GBP: "پوند",
  AED: "درهم",
  TRY: "لیر",
  CAD: "دلار کانادا",
  // Add other currencies as needed
};

const getCurrencyNameInPersian = (name) => {
  return translations[name] || name; // Fallback to name if no translation exists
};

const UniversalPricesPage = ({ uniPrices }) => {
  // console.log(uniPrices);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulating a fetch request
    const fetchData = async () => {
      setLoading(true); // Start loading
      if (uniPrices && uniPrices.length !== 0) {
        setLoading(false); // Stop loading after data is "fetched"
      }
    };

    fetchData();
  }, [uniPrices]);

  // Order for the currencies
  const desiredOrder = ["EUR", "TRY", "USD", "AED", "GBP", "CAD"];

  // Sort uniPrices based on the desired order
  const sortedUniPrices = uniPrices?.sort((a, b) => {
    const indexA = desiredOrder.indexOf(a.name);
    const indexB = desiredOrder.indexOf(b.name);
    return indexA - indexB;
  });

  return (
    <Fragment>
      <div className="uniprice-table-container flex justify-between items-center gap-[2.56rem] max-[580px]:flex-col">
        <>
          <table className="w-[50%] max-[580px]:!w-[100%]">
            <thead>
              <tr>
                <th></th>
                <th>نرخ های جهانی</th>
                <th>تبدیل</th>
              </tr>
            </thead>
            <tbody>
              {sortedUniPrices?.slice(0, 9).map((c, index) => (
                <tr key={index}>
                  <td>
                    {/* <img src={star} alt="star" /> */}
                  </td>
                  <td className="flex justify-start items-center text-center align-middle whitespace-nowrap">
                    <div className="currency-flag flex">
                      <img
                        src={getFlagUrl(c.name)}
                        alt={c.name}
                      />
                      <img
                        src={arrow}
                        alt="arrow"
                        className="max-[580px]:!w-[1.5rem]"
                      />
                      <img
                        src={getFlagUrl(c.base)}
                        alt={c.base}
                      />
                    </div>
                    <div className="currency-name">
                      {getCurrencyNameInPersian(c.name)} \{" "}
                      {getCurrencyNameInPersian(c.base)}
                    </div>
                  </td>
                  <td className="text-center align-middle whitespace-nowrap">
                    <div
                      className={`flex justify-center items-center price-value ${
                        c.price === c.prePrice
                          ? ""
                          : c.price >= c.prePrice
                          ? "green"
                          : "red"
                      }`}
                    >
                      {c.price.toLocaleString()}
                      <div className="price-icon">
                        {c.price === c.prePrice ? (
                          "---"
                        ) : (
                          <img
                            className="max-[580px]:w-[1.5rem]"
                            src={c.price >= c.prePrice ? up : down}
                            alt=""
                          />
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <table className="w-[50%] max-[580px]:!w-[100%]">
            <thead>
              <tr>
                <th></th>
                <th>نرخ های جهانی</th>
                <th>تبدیل</th>
              </tr>
            </thead>
            <tbody>
              {sortedUniPrices?.slice(9, 18).map((c, index) => (
                <tr key={index}>
                  <td>
                    {/* <img src={star} alt="star" /> */}
                  </td>
                  <td className="flex justify-start items-center text-center align-middle whitespace-nowrap">
                    <div className="currency-flag flex">
                      <img
                        src={getFlagUrl(c.name)}
                        alt={c.name}
                      />
                      <img
                        src={arrow}
                        alt="arrow"
                        className="max-[580px]:!w-[1.5rem]"
                      />
                      <img
                        src={getFlagUrl(c.base)}
                        alt={c.base}
                      />
                    </div>
                    <div className="currency-name">
                      {getCurrencyNameInPersian(c.name)} \{" "}
                      {getCurrencyNameInPersian(c.base)}
                    </div>
                  </td>
                  <td className="text-center align-middle whitespace-nowrap">
                    <div
                      className={`flex justify-center items-center price-value ${
                        c.price === c.prePrice
                          ? ""
                          : c.price >= c.prePrice
                          ? "green"
                          : "red"
                      }`}
                    >
                      {c.price.toLocaleString()}
                      <div className="price-icon">
                        {c.price === c.prePrice ? (
                          "---"
                        ) : (
                          <img
                            className="max-[580px]:w-[1.5rem]"
                            src={c.price >= c.prePrice ? up : down}
                            alt=""
                          />
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      </div>
      {loading && (
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
      )}
    </Fragment>
  );
};

export default UniversalPricesPage;
